import { MutationTree } from "vuex";
import { TOWER_ALERT_REVIEW_LOAD } from "./mutation_types";
import { TowerState } from "./types";

export const mutations: MutationTree<TowerState> = {
  [TOWER_ALERT_REVIEW_LOAD](
    state,
    towerReviewData: Array<Record<string, any>>
  ) {
    state.data.towerReview = towerReviewData;
  }
};
